import { connect } from 'react-redux';
import React from 'react';
import { Modal, Form, Grid, Button } from 'semantic-ui-react';
import { Form as FinalForm, FormRenderProps } from 'react-final-form';

import FieldValue from 'components/FieldValue';
import { SprayEventStartDate } from 'services/sprayEvents/types';
import { updateQueryString as updateQueryStringAction } from 'services/router/actions';
import { PRINT_WORKSHEET_MODAL } from 'components/PrintWorksheetModal/constants';
import { WorksheetType } from 'services/worksheet/types';
import DayOfTheWeekField from './components/DayOfTheWeekField';
import ApplicatorField from './components/ApplicatorField';
import { VIEW_WORKSHEET_MODAL } from './constants';

export interface DispatchProps {
    updateQueryString: typeof updateQueryStringAction;
}

export interface OwnProps {
    worksheetType: WorksheetType;
}

export type Props = DispatchProps & OwnProps;

type FormValues = {
    operatorPersonId: string;
    dayOfTheWeek: string;
};

export class WorksheetFormComponent extends React.PureComponent<Props> {
    handleSubmit = (values: FormValues): void => {
        this.props.updateQueryString({
            [VIEW_WORKSHEET_MODAL]: undefined,
            [PRINT_WORKSHEET_MODAL]: true,
            worksheetOperatorPersonId: values.operatorPersonId,
            worksheetDate: values.dayOfTheWeek
        });
    };

    handleOnClose = (): void => {
        this.props.updateQueryString({
            [VIEW_WORKSHEET_MODAL]: undefined
        });
    };

    render(): React.ReactElement {
        const { worksheetType } = this.props;

        return (
            <React.Fragment>
                <Modal.Header>View Worksheet</Modal.Header>
                <Modal.Content>
                    <FinalForm
                        onSubmit={this.handleSubmit}
                        render={(
                            props: FormRenderProps<FormValues>
                        ): React.ReactElement => {
                            const { handleSubmit } = props;

                            return (
                                <Form
                                    autoComplete="off"
                                    onSubmit={handleSubmit}
                                >
                                    <DayOfTheWeekField
                                        worksheetType={worksheetType}
                                    />
                                    <FieldValue name="dayOfTheWeek">
                                        {(
                                            dayOfTheWeek: SprayEventStartDate
                                        ): React.ReactElement => (
                                            <ApplicatorField
                                                eventStartDate={dayOfTheWeek}
                                                worksheetType={worksheetType}
                                            />
                                        )}
                                    </FieldValue>
                                    <Grid>
                                        <Grid.Column
                                            mobile={16}
                                            tablet={8}
                                            computer={8}
                                        >
                                            <Button
                                                type="button"
                                                color="grey"
                                                onClick={this.handleOnClose}
                                                fluid
                                                basic
                                                primary
                                            >
                                                Cancel
                                            </Button>
                                        </Grid.Column>
                                        <Grid.Column
                                            mobile={16}
                                            tablet={8}
                                            computer={8}
                                        >
                                            <Button type="submit" primary fluid>
                                                View
                                            </Button>
                                        </Grid.Column>
                                    </Grid>
                                </Form>
                            );
                        }}
                    />
                </Modal.Content>
            </React.Fragment>
        );
    }
}

export default connect(null, {
    updateQueryString: updateQueryStringAction
})(WorksheetFormComponent);
